var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/home.template.html');

var GeneralView = require('views/general.view.ts');
var LoadView = require('views/load.view.ts');
var ComponentsView = require('views/components.view.ts');
var ElectricityView = require('views/electricity_pricing.view.ts');
var EnergyView = require('views/energy_billing.view.ts');
var ProjectView = require('views/project.view.ts');
var ResultsView = require('views/results.view.ts');

require("notify");

var TheView = GenericView.extend({
    el: '#container',
    tagName: '',
	template: Handlebars.compile(Template),
	tabsMap: {},
	currentTabsIndex: 0,
	has_error: false,
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template());
        this.renderTabsContent();
    },
    events: {
        "click .ui-tabview-nav.first .nav-item": "changeTab",
        "click #previous": "prevTab",
        "click #next": "nextTab",
        "click #reset": "reset"
    },
    changeTab: function(event) {
        this.currentTabsIndex = $(event.currentTarget).data("index");

        $(".ui-tabview-nav.first").find("li.active").removeClass("active");
        $(event.currentTarget).addClass("active");

        $(".ui-tabview-panels.first > .show").removeClass("show");
        var id = $(event.currentTarget).data("id");
        $("#" + id).addClass("show");
    },
    findActiveTab: function(tabID) {
        $(".ui-tabview-nav.first").find("li.active").removeClass("active");
        $('.nav-item[data-id=' + tabID + ']').addClass("active");

        $(".ui-tabview-panels.first > .show").removeClass("show");
        $("#" + tabID).addClass("show");
    },
    nextTab: function() {
        var currentView = this.tabsMap[this.currentTabsIndex].view;
        this.has_error = false;//currentView.validateAll();

        if (!this.has_error) {
            if (this.currentTabsIndex < 6) {
                this.currentTabsIndex = this.currentTabsIndex + 1;
                nextTab_id = this.tabsMap[this.currentTabsIndex].name;
                this.findActiveTab(nextTab_id);
            }
        } else {
            $.notify("Error: Please check the fields on this tab.",{className: "error", position: "top left"});
        }
    },
    prevTab: function() {
        if (this.currentTabsIndex > 0) {
            this.currentTabsIndex = this.currentTabsIndex - 1;
            prevTab_id = this.tabsMap[this.currentTabsIndex].name;
            this.findActiveTab(prevTab_id);
        }
    },
    reset: function() {
        if (confirm("Are you sure you want to reset the data?") == true) {
             location.reload();
        } else {
            return ;
        }
    },
    renderTabsContent: function() {

        this.tabsMap = [
            { view:  new GeneralView(), name: "general" },
            { view:  new LoadView(), name: "load" },
            { view:  new ComponentsView(), name: "components" },
            { view:  new ElectricityView(), name: "electricity" },
            { view:  new EnergyView(), name: "energy" },
            { view:  new ProjectView(), name: "project" },
            { view:  new ResultsView(), name: "results" }
        ]

    }
});

module.exports= TheView;